import React, {useMemo} from 'react';
import {useProjectTelReportsByCapitalFundRangeQuery} from 'api';
import {useParams} from 'react-router-dom';
import Table from '../Table';

export default () => {
  const {projectId} = useParams<{projectId: string}>();

  const {data: {projectTelReportsByCapitalFundRange = []} = {}} =
    useProjectTelReportsByCapitalFundRangeQuery({
      variables: {uuid: projectId},
      fetchPolicy: 'cache-and-network',
    });

  const data: any = useMemo(
    () =>
      projectTelReportsByCapitalFundRange.map((report) => {
        return {
          name: report.capitalFundRange,
          callCount: report.callCount,
          contactCount: report.contactCount,
          contactCallRate: report.contactCallRate,
          documentCount: report.documentCount,
          documentCallRate: report.documentCallRate,
          appointCount: report.appointCount,
          appointCallRate: report.appointCallRate,
        };
      }),
    [projectTelReportsByCapitalFundRange],
  );

  return <Table data={data} />;
};
